<template>
  <div class="page-login">
    <form
      action="#"
      novalidate
    >
      <h1>OptiSales Login</h1>
      <h2>Use your email to login</h2>
      <input
        type="email"
        placeholder="Email"
      >
      <input
        type="password"
        placeholder="Password"
      >
      <div class="keep">
        <input
          id="keepLoggedIn"
          type="checkbox"
        >
        <label for="keepLoggedIn">
          <div class="indicator" />
          Keep me logged in
        </label>
      </div>
      <button
        class="login-btn"
        @click.prevent="login"
      >
        Log in
      </button>
    </form>
  </div>
</template>
<script>

export default {
  name: 'page-login',
  methods: {
    async login() {
      const loader = this.$loading.show();
      const minWait = 100;
      const wait = Math.floor(Math.random() * Math.floor(7)) * 100;
      await new Promise(resolve => setTimeout(resolve, wait > 100 ? wait : minWait));
      this.$ls.set('isLoggedIn', true, 1000 * 60 * 60 * 24);
      this.$store.state.isLoggedIn = true;
      loader.hide();
      this.$router.push({ path: '/' });
    },
  },
};
</script>

<style scoped lang="scss">
.page-login {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  color: #6e7c91;

  form {
    box-shadow: 0 22px 25px 2px rgba(77, 89, 94, 0.04);
    border-radius: 3px;
    background-color: #fff;
    padding: 36px;
    min-width: 390px;

    input {
      display: block;
      width: 100%;
      padding: 12px;
      margin-bottom: 20px;
      border: none;
      border-bottom: 2px solid rgba(#b6c4cc, .45);
      color: #6974de;
      font-weight: 700;

      &:focus {
        outline: none;
        border-bottom-color: #6974de;
      }

      &::placeholder {
        font-weight: 500;
      }
    }

    .keep {
      margin-bottom: 60px;

      input {
        position: absolute;
        z-index: -1000;
        opacity: 0;

        &:checked {
          &+label {
            .indicator {
              &::before, &::after {
                opacity: 1;
              }
            }
          }
        }
      }

      label {
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        position: relative;
        padding-left: 25px;

        .indicator {
          width: 16px;
          height: 16px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          border-radius: 3px;
          background-color: #6974de;

          &::before, &::after {
            content: '';
            display: inline-block;
            width: 10px;
            height: 2px;
            background-color: #fff;
            border-radius: 2px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: rotate(45deg) translate(-50%, -50%);
            transform-origin: 0 0;
            opacity: 0;
          }

          &::after {
            transform: rotate(-45deg) translate(-50%, -50%);
          }
        }
      }
    }

    .login-btn {
      padding: 10px 12px;
      box-shadow: 0 2px 3px 1px rgba(50, 51, 90, 0.23);
      border: none;
      border-radius: 3px;
      background-color: #32335a;
      color: #fff;
      font-size: 14px;
      font-weight: 700;
      text-transform: uppercase;
      cursor: pointer;
    }
  }

  h1 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  h2 {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 36px;
  }
}
</style>
